import React from "react";
import { Menu, MenuItem } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { ReceiptText, ShieldOff } from "lucide-react";

const MenuTransactionItem = (props) => {
  const {
    handleMenuClose,
    anchorEl,
    selectedTransaction,
    handleUnauditRecord,
    havePatientInfoPermission,
    haveUnauditPermission,
  } = props;

  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
    >
      {havePatientInfoPermission && (
        <MenuItem
          component={NavLink}
          to={`/transaction-detail`}
          className="hover:text-black"
          state={{
            id: selectedTransaction?._id || "",
            practice: selectedTransaction?.practiceId || "",
            practiceName: selectedTransaction?.practiceName || "",
          }}
          style={{ display: "flex", gap: 10, alignItems: "center" }}
        >
          <ReceiptText className="h-5 w-5" /> More Details
        </MenuItem>
      )}
      {selectedTransaction?.audited && haveUnauditPermission && (
        <MenuItem
          onClick={() => {
            handleMenuClose();
            handleUnauditRecord(selectedTransaction);
          }}
          className="hover:text-black"
          style={{ display: "flex", gap: 10, alignItems: "center" }}
        >
          <ShieldOff className="h-5 w-5" /> Unaudit
        </MenuItem>
      )}
    </Menu>
  );
};

export default MenuTransactionItem;
